import React from 'react';
import ReactDOM from 'react-dom/client';
import $ from 'jquery';

// Owl Carousel expects jQuery globals to exist before its modules load.
window.$ = window.jQuery = $;

const App = require('./App').default;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
